"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bytesToMegaBytes = function (bytes, digits) {
    var BYTES_PER_KILOBYTE = 1000;
    var BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * BYTES_PER_KILOBYTE;
    var result = bytes / BYTES_PER_MEGABYTE;
    return digits ? result.toFixed(digits) : result;
};
exports.default = bytesToMegaBytes;
